import { isNumber } from 'lodash';

import type {
  DiscountType,
  PriceRoundingMethod,
  TaxType,
} from '@flow/libs/data-validators/entity-schemas/document-box/product-table';

import {
  PRICE_ROUNDING_METHOD,
  PRODUCT_DISCOUNT_TYPE_NONE,
  PRODUCT_DISCOUNT_TYPE_NUMERIC,
  PRODUCT_DISCOUNT_TYPE_PERCENTAGE,
  PRODUCT_TAX_TYPE_NONE,
  PRODUCT_TAX_TYPE_PERCENTAGE,
} from '@flow/libs/agreement/boxes/product-constants';

export const CURRENT_PRICE_ROUNDING_METHOD = PRICE_ROUNDING_METHOD.BANKERS;

export const isDiscountNone = (discountType: DiscountType) =>
  discountType === PRODUCT_DISCOUNT_TYPE_NONE;

export const isDiscountPercentage = (discountType: DiscountType) =>
  discountType === PRODUCT_DISCOUNT_TYPE_PERCENTAGE;

export const isDiscountNumeric = (discountType: DiscountType) =>
  discountType === PRODUCT_DISCOUNT_TYPE_NUMERIC;

export const isTaxNone = (taxType: TaxType) => taxType === PRODUCT_TAX_TYPE_NONE;

export const isTaxPercentage = (taxType: TaxType) => taxType === PRODUCT_TAX_TYPE_PERCENTAGE;

export const shouldDisplayDiscount = (sum: unknown, sumDiscounted: unknown) =>
  isNumber(sumDiscounted) && isNumber(sum) && sumDiscounted !== sum;

export type PriceInfo = number;

export type Options = {
  roundPrice?: boolean;
  roundingMethod?: PriceRoundingMethod;
};

// or const number = Math.trunc(0.03333 * 100 * Math.pow(10, 14)) / Math.pow(10, 14)
// TODO: Edge case: numbers with more preceding zeros in the decimal part
// will get scientific notation
// Eg.,: "0.0000003333" -> "3.333e-7". use regex and convert
export const getDisplayPercentage = (amount?: number, preferredPrecisions = 10) =>
  amount && String(Number((amount * 100).toExponential(preferredPrecisions)));
